import { CONFIG_NODE_ENV } from '@/utils/constants/config';

const IS_ENV_DEVELOPMENT = CONFIG_NODE_ENV === 'development';
const IS_ENV_PRODUCTION = CONFIG_NODE_ENV === 'production';
const IS_ENV_TEST = CONFIG_NODE_ENV === 'test';

export { IS_ENV_DEVELOPMENT, IS_ENV_PRODUCTION, IS_ENV_TEST };
